/**
 * Cache-busting query string appended to static asset URLs (images, language
 * files, worker/lib scripts). Bump this single value to invalidate the
 * browser cache for all of them at once.
 *
 * Kept as the full "?versionid=231" string (not just the number) so that a
 * plain find-and-replace of the old literal across the repo also catches
 * this file in the same pass as the handful of static HTML/JSON files that
 * can't import it (see react/features/utils/ for context).
 */
export const ASSET_VERSION_QUERY = '?versionid=231';
